"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgPopupUpdate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M48.977 11C44.027 4.9 36.47 1 28 1 13.088 1 1 13.088 1 28c0 4.51 1.106 8.763 3.062 12.5m2.96 4.5C11.974 51.1 19.533 55 28 55c14.912 0 27-12.088 27-27a26.89 26.89 0 00-3-12.382",
    stroke: props.color || "#133251",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 11h8V3M15 45H7v8m26.333-38c2.002 0 3.595 1.544 3.665 3.428l.002.139v18.875c0 1.9-1.548 3.486-3.531 3.556l-.144.002H22.667c-2.002 0-3.595-1.544-3.665-3.428L19 37.433V18.558c0-1.9 1.548-3.486 3.531-3.556l.144-.002h10.658z",
    stroke: props.color || "#133251",
    strokeWidth: 2
  }));
}

var _default = SvgPopupUpdate;
exports["default"] = _default;